<template>
  <v-container fluid class="help">
    <v-row>
      <v-col class="text-center">
        <h1>Witness Document</h1>
        <br><br>
        <hr>
        <br>
        
        <!-- intro form -->
        <v-col class="text-left" v-if="!isIntroFinished">
          <p>
            Kepada Pelanggan yang kami hargai, <br><br> 
            Terima kasih kerana  menyokong kami Zurich Takaful. Sebelum pihak kami memproses permohonan anda, kami memerlukan tiga (3) orang  saksi  untuk  permohonan ini. Saksi yang hendak dilantik hendaklah  orang  yang anda percaya dan rapat. Tujuannya adalah  sekiranya  berlaku sesuatu terhadap anda, mereka  inilah  yang  akan  memaklumkan  pada  syarikat Zurich Takaful untuk  membuat tuntutan. Suka kami ingatkan bahawa saksi ini bukannya  waris  atau penjamin (guarantor). Ini  adalah keperluan  prosedur operasi standard (SOP)  syarikat kami untuk  setiap  polisi yang dimohon.  Ini kerana terlalu banyak  kes dimana  pemilik takaful meninggal dan tiada siapa yang memaklumkan kepada  pihak takaful untuk buat tuntutan. Selain itu, ada juga  kes  yang berlaku,  pemilik takaful meninggal namun pihak keluarga  tidak  tahu.  Ada juga  kes yang berlaku,  di mana pemilik takaful meninggal, ejen yang bertanggung jawab sudah tiada. Semua ini adalah punca utama kelewatan atau tiada bayaran tuntutan pampasan yang berlaku di syarikat takaful. Syarikat takaful tiada maklumat bahawa pemilik takaful meninggal dunia.
            <br><br>
            Pihak kami akan  berjumpa  setiap saksi anda tersebut untuk dapatkan  tandatangan  mereka  sebagai  saksi.   Jadi, sebelum pihak kami hubungi mereka untuk dapatkan sesi temujanji, adalah sangat perlu untuk anda hubungi mereka sekarang untuk memaklumkan bahawa mereka telah dilantik sebagai saksi  untuk permohonan polisi anda ini dan maklumkan juga pihak kami akan temui mereka dalam masa terdekat untuk dapatkan tandatangan mereka.
            <br><br>
            Kami akan  terangkan  pada  mereka  nanti apa  yang  anda telah mohon dengan Takaful Zurich ,  apa  perlindungan yang ada,  dan  jenis  produk. Untuk makluman, kami tidak akan sesekali memberitahu berapa caruman yang anda bayar, sebab  itu  adalah  P&C.
            <br><br>
            Terima kasih.
            <br><br>
            Pihak Pengurusan Teras Legacy.
            www.teraslegacy.com
            
          </p>
          <br>
          <v-checkbox
            v-model="isAgreeToContinue"
            label="Saya bersetuju melantik 3 orang saksi untuk  permohonan saya ini."
          ></v-checkbox>
          <v-btn
            :disabled="!isAgreeToContinue"
            color="primary"
            @click="finishReadingIntro()"
          >
              Teruskan
          </v-btn>
        </v-col>

        <!-- details form -->
        <v-form
          v-else 
          ref="form" 
          @submit.prevent="submit">

          <v-container fluid>
            <v-col>
              <v-btn
                color="primary"
                @click="finishReadingIntro()"
              >
                Papar Semula Pendahuluan
              </v-btn>
              <br><br><br><hr><br><br>
            </v-col>

            <v-row>
              <p>Maklumat Ejen</p>
              <v-col cols="12">
                <v-text-field
                  v-model="agentName"
                  :rules="formRules.text"
                  color="blue darken-2"
                  label="Nama Ejen"
                  outlined
                  class="text-input"
                ></v-text-field>
              </v-col>
              <br>

              <p>Maklumat Saksi Pertama</p>
              <v-col cols="12">
                <v-text-field
                    v-model="witnessName1"
                    :rules="formRules.text"
                    color="blue darken-2"
                    label="Nama"
                    outlined
                    class="text-input"
                ></v-text-field>
                <br>
                <v-text-field
                    v-model="line1WitnessAddress1"
                    :rules="formRules.text"
                    color="blue darken-2"
                    label="Alamat"
                    placeholder="Cth: No 10, Jalan Setia Tropika 1/21"
                    hint="Cth: No 10, Jalan Setia Tropika 1/21"
                    outlined
                    class="text-input"
                ></v-text-field>
                <v-text-field
                    v-model="line2WitnessAddress1"
                    color="blue darken-2"
                    placeholder="Cth: Taman Setia Tropika"
                    hint="Cth: Taman Setia Tropika"
                    outlined
                    class="text-input"
                ></v-text-field>
                <v-text-field
                    v-model="line3WitnessAddress1"
                    color="blue darken-2"
                    placeholder="Cth: 81200, Johor Bahru, Johor."
                    hint="Cth: 81200, Johor Bahru, Johor."
                    outlined
                    class="text-input"
                ></v-text-field>
                <br>
                <v-text-field
                    v-model="witnessPhoneNumber1"
                    :rules="formRules.text"
                    color="blue darken-2"
                    label="No Telefon"
                    outlined
                    class="text-input"
                ></v-text-field>
              </v-col>

              <br><br>

              <p>Maklumat Saksi Kedua</p>
              <v-col cols="12">
                <v-text-field
                    v-model="witnessName2"
                    :rules="formRules.text"
                    color="blue darken-2"
                    label="Nama"
                    outlined
                    class="text-input"
                ></v-text-field>
                <br>
                <v-text-field
                    v-model="line1WitnessAddress2"
                    :rules="formRules.text"
                    color="blue darken-2"
                    label="Alamat"
                    placeholder="Cth: No 10, Jalan Setia Tropika 1/21"
                    hint="Cth: No 10, Jalan Setia Tropika 1/21"
                    outlined
                    class="text-input"
                ></v-text-field>
                <v-text-field
                    v-model="line2WitnessAddress2"
                    color="blue darken-2"
                    placeholder="Cth: Taman Setia Tropika"
                    hint="Cth: Taman Setia Tropika"
                    outlined
                    class="text-input"
                ></v-text-field>
                <v-text-field
                    v-model="line3WitnessAddress2"
                    color="blue darken-2"
                    placeholder="Cth: 81200, Johor Bahru, Johor."
                    hint="Cth: 81200, Johor Bahru, Johor."
                    outlined
                    class="text-input"
                ></v-text-field>
                <br>
                <v-text-field
                    v-model="witnessPhoneNumber2"
                    :rules="formRules.text"
                    color="blue darken-2"
                    label="No Telefon"
                    outlined
                    class="text-input"
                ></v-text-field>
              </v-col>
        
              <br><br>

              <p>Maklumat Saksi Ketiga</p>
              <v-col cols="12">
                <v-text-field
                  v-model="witnessName3"
                  :rules="formRules.text"
                  color="blue darken-2"
                  label="Nama"
                  outlined
                  class="text-input"
                ></v-text-field>
                <br>
                <v-text-field
                  v-model="line1WitnessAddress3"
                  :rules="formRules.text"
                  color="blue darken-2"
                  label="Alamat"
                  placeholder="Cth: No 10, Jalan Setia Tropika 1/21"
                  hint="Cth: No 10, Jalan Setia Tropika 1/21"
                  outlined
                  class="text-input"
                ></v-text-field>
                <v-text-field
                  v-model="line2WitnessAddress3"
                  color="blue darken-2"
                  placeholder="Cth: Taman Setia Tropika"
                  hint="Cth: Taman Setia Tropika"
                  outlined
                  class="text-input"
                ></v-text-field>
                <v-text-field
                  v-model="line3WitnessAddress3"
                  color="blue darken-2"
                  placeholder="Cth: 81200, Johor Bahru, Johor."
                  hint="Cth: 81200, Johor Bahru, Johor."
                  outlined
                  class="text-input"
                ></v-text-field>
                <br>
                <v-text-field
                  v-model="witnessPhoneNumber3"
                  :rules="formRules.text"
                  color="blue darken-2"
                  label="No Telefon"
                  outlined
                  class="text-input"
                ></v-text-field>
              </v-col>
              
              <br><br>

              <p>Maklumat Pelanggan</p>
              <v-col cols="12">
                <v-text-field
                  v-model="policyHolderName"
                  :rules="formRules.text"
                  color="blue darken-2"
                  label="Nama"
                  outlined
                  class="text-input"
                ></v-text-field>
                <v-text-field
                  v-model="policyHolderDate"
                  :rules="formRules.text"
                  color="blue darken-2"
                  label="Tarikh (Auto)"
                  hint="12/05/2022"
                  outlined
                  class="text-input"
                  disabled
                ></v-text-field>
              </v-col>

              <!-- sign canvas -->
              <v-row justify-md="space-around">
                <v-col sm="6" md="6">
                  <p><b>Tanda Tangan Pelanggan</b></p>
                  <v-btn @click="clearSignCanvas()">Clear</v-btn>
                  <br><br>
                  <VueSignatureCanvas
                    ref="handWrite"
                    class="sig-canvas pa-5"
                  />
                </v-col>
              </v-row> 

            </v-row>
          </v-container>
          <br><br>

          <v-btn
            :disabled="!formIsValid"
            color="primary"
            type="submit"
          >
            Generate
          </v-btn>
        </v-form>
        <br><br>

        <!--
        <v-btn
            color="primary"
            @click="testDb"
          >
            Test Db
          </v-btn>-->
        
        <!-- overlay submit form response-->
        <v-overlay :value="overlay">
          <v-card
            class="mx-auto pa-4"
            max-width="344"
            outlined
          > 
            <br>
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            <h3 class="title ma-3">Generating form</h3><p class="sub-title">Will be downloaded automatically.</p>
            
            <v-btn
              icon
              @click="overlay = false"
              x-large
              >
              <v-icon>{{mdiClose}}</v-icon>
              Dismiss
            </v-btn>
          </v-card>
        </v-overlay>
      
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import  VueSignatureCanvas  from 'vue-signature-canvas'
import { PDFDocument } from 'pdf-lib'
import { getDatabase, ref as refDb, push } from "firebase/database"
import { dbPaths } from "../assets/dbPaths.js"
import { mdiClose } from '@mdi/js'

export default {
  components: {
		VueSignatureCanvas
  },

  data: () => ({
    mdiClose,
    isIntroFinished: false,
    isAgreeToContinue: false,

    //form data.
    agentName: '',
    policyHolderName: '',
    policyHolderDate: '',
    signImageUrl: '',

    witnessName1: '',
    line1WitnessAddress1: '',
    line2WitnessAddress1: '',
    line3WitnessAddress1: '',
    witnessPhoneNumber1: '',

    witnessName2: '',
    line1WitnessAddress2: '',
    line2WitnessAddress2: '',
    line3WitnessAddress2: '',
    witnessPhoneNumber2: '',

    witnessName3: '',
    line1WitnessAddress3: '',
    line2WitnessAddress3: '',
    line3WitnessAddress3: '',
    witnessPhoneNumber3: '',

    formRules: {
      text: [val => (val || '').length > 0 || 'This field is required'],
    },

    overlay: false,

    pdfLink: 'pdf/witness-form.pdf',
  }),

  mounted () {
    
    const date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
    const [year, month, day] = date.split('-');
    const displayDate = day + '/' + month + '/' + year 
    //console.log('date : ' + displayDate);
    this.policyHolderDate = displayDate
    
  },

  computed: {
    formIsValid () {
      return (
        this.agentName && this.policyHolderName && this.policyHolderDate && 
        !this.$refs.handWrite.isEmpty() &&
        this.witnessName1 && this.line1WitnessAddress1 && this.witnessPhoneNumber1
      )
    },
  },

  methods: {
    finishReadingIntro() {
      if (this.isIntroFinished) {
        this.isIntroFinished = false
      } else {
        window.scrollTo(0,0);
        this.isIntroFinished = true
      }
    },

    clearSignCanvas() {
        this.$refs.handWrite.clear()
    },

    getFinalX(xFromPsd) {
      return (xFromPsd/21) * 595.256
    },
    getFinalY(yFromPsd) {
      return ((29.7-yFromPsd)/29.7) * 841.8898
    },

    //submit form.
    submit() {

      this.overlay = true

      //push data to db.
      const db = getDatabase();
      const date = new Date();

      push(refDb(db, dbPaths.toWitnessProgram() + date.getFullYear() + '/' + date.getMonth()), {
        agent_code: window.sessionStorage.getItem('agentCode').toUpperCase(),
        agent_name: this.agentName.toUpperCase(),
        date: date.toDateString(),
        time: date.toLocaleTimeString(),

        policy_holder_name: this.policyHolderName.toUpperCase(),
        policy_holder_date: this.policyHolderDate.toUpperCase(),

        first_witness_name: this.witnessName1.toUpperCase(),
        first_witness_address: this.line1WitnessAddress1.toUpperCase() + ' ' + this.line2WitnessAddress1.toUpperCase() + ' ' + this.line3WitnessAddress1.toUpperCase(),
        first_witness_phone: this.witnessPhoneNumber1,

        second_witness_name: this.witnessName2.toUpperCase(),
        second_witness_address: this.line1WitnessAddress2.toUpperCase() + ' ' + this.line2WitnessAddress2.toUpperCase() + ' ' + this.line3WitnessAddress2.toUpperCase(),
        second_witness_phone: this.witnessPhoneNumber2,

        third_witness_name: this.witnessName3.toUpperCase(),
        third_witness_address: this.line1WitnessAddress3.toUpperCase() + ' ' + this.line2WitnessAddress3.toUpperCase() + ' ' + this.line3WitnessAddress3.toUpperCase(),
        third_witness_phone: this.witnessPhoneNumber3,
      })
      .then(async () => {
        // Data saved successfully!

        this.signImageUrl = this.$refs.handWrite.getCanvas().toDataURL()
        
        const existingPdfBytes = await fetch(this.pdfLink).then(res => res.arrayBuffer())
        const pdfDoc = await PDFDocument.load(existingPdfBytes)
        //const pdfDoc = await PDFDocument.load(proposalImages.witnessForm())
        const pages = pdfDoc.getPages()

        const imageSign = await pdfDoc.embedPng(this.signImageUrl)
        const pngDims = imageSign.scaleToFit(113.39, 56.69) //unit used = pt.

        //page1 input
          const page1 = pages[0]

          page1.drawText(this.witnessName1.toUpperCase(), {
            x: this.getFinalX(6.75),
            y: this.getFinalY(9.68),
            size: 12,
          })
          page1.drawText(this.line1WitnessAddress1.toUpperCase(), {
            x: this.getFinalX(6.75),
            y: this.getFinalY(11.26),
            size: 12,
          })
          if(this.line2WitnessAddress1) {
            page1.drawText(this.line2WitnessAddress1.toUpperCase(), {
              x: this.getFinalX(6.75),
              y: this.getFinalY(12.03),
              size: 12,
            })
          }
          if (this.line3WitnessAddress1) {
            page1.drawText(this.line3WitnessAddress1.toUpperCase(), {
              x: this.getFinalX(6.75),
              y: this.getFinalY(12.83),
              size: 12,
            })
          }
          page1.drawText(this.witnessPhoneNumber1.toUpperCase(), {
            x: this.getFinalX(6.75),
            y: this.getFinalY(15.20),
            size: 12,
          })
          page1.drawText(this.policyHolderName.toUpperCase(), {
            x: this.getFinalX(4.00),
            y: this.getFinalY(24.00),
            size: 12,
          })
          page1.drawText(this.policyHolderDate.toUpperCase(), {
            x: this.getFinalX(4.00),
            y: this.getFinalY(24.75),
            size: 12,
          })
          page1.drawImage(imageSign, {
            x: this.getFinalX(3.00),
            y: this.getFinalY(23.40),
            width: pngDims.width,
            height: pngDims.height,
          })

        //page 2 input
          const page2 = pages[1]

          page2.drawText(this.witnessName2.toUpperCase(), {
            x: this.getFinalX(6.75),
            y: this.getFinalY(9.68),
            size: 12,
          })
          page2.drawText(this.line1WitnessAddress2.toUpperCase(), {
            x: this.getFinalX(6.75),
            y: this.getFinalY(11.26),
            size: 12,
          })
          if (this.line2WitnessAddress2) {
            page2.drawText(this.line2WitnessAddress2.toUpperCase(), {
              x: this.getFinalX(6.75),
              y: this.getFinalY(12.03),
              size: 12,
            })
          }
          if (this.line3WitnessAddress2) {
            page2.drawText(this.line3WitnessAddress2.toUpperCase(), {
              x: this.getFinalX(6.75),
              y: this.getFinalY(12.83),
              size: 12,
            })
          }
          page2.drawText(this.witnessPhoneNumber2.toUpperCase(), {
            x: this.getFinalX(6.75),
            y: this.getFinalY(15.20),
            size: 12,
          })
          page2.drawText(this.policyHolderName.toUpperCase(), {
            x: this.getFinalX(4.00),
            y: this.getFinalY(24.00),
            size: 12,
          })
          page2.drawText(this.policyHolderDate.toUpperCase(), {
            x: this.getFinalX(4.00),
            y: this.getFinalY(24.75),
            size: 12,
          })
          page2.drawImage(imageSign, {
            x: this.getFinalX(3.00),
            y: this.getFinalY(23.40),
            width: pngDims.width,
            height: pngDims.height,
          })

        
        //page3 input
          const page3 = pages[2]
          page3.drawText(this.witnessName3.toUpperCase(), {
            x: this.getFinalX(6.75),
            y: this.getFinalY(9.68),
            size: 12,
          })
          page3.drawText(this.line1WitnessAddress3.toUpperCase(), {
            x: this.getFinalX(6.75),
            y: this.getFinalY(11.26),
            size: 12,
          })
          if (this.line2WitnessAddress3) {
            page3.drawText(this.line2WitnessAddress3.toUpperCase(), {
              x: this.getFinalX(6.75),
              y: this.getFinalY(12.03),
              size: 12,
            })
          }
          if (this.line3WitnessAddress3) {
            page3.drawText(this.line3WitnessAddress3.toUpperCase(), {
              x: this.getFinalX(6.75),
              y: this.getFinalY(12.83),
              size: 12,
            })
          }
          page3.drawText(this.witnessPhoneNumber3.toUpperCase(), {
            x: this.getFinalX(6.75),
            y: this.getFinalY(15.20),
            size: 12,
          })
          page3.drawText(this.policyHolderName.toUpperCase(), {
            x: this.getFinalX(4.00),
            y: this.getFinalY(24.00),
            size: 12,
          })
          page3.drawText(this.policyHolderDate.toUpperCase(), {
            x: this.getFinalX(4.00),
            y: this.getFinalY(24.75),
            size: 12,
          })
          page3.drawImage(imageSign, {
            x: this.getFinalX(3.00),
            y: this.getFinalY(23.40),
            width: pngDims.width,
            height: pngDims.height,
          })
          
     
        //generate and download.
          const pdfBytes = await pdfDoc.save()
          const blob = new Blob([pdfBytes], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "Witness-Form-" + this.policyHolderName + ".pdf";
          link.click();
          URL.revokeObjectURL(link.href);
      })
      .catch((error) => {
        // The write failed...
        console.log(error);
      });

    },


    //experiment code. -[ start ]--------------------------------
    getData() {
      console.log('name : ' + this.witnessName1);
      console.log('address : ' + this.line1WitnessAddress1);
      console.log('phone : ' + this.witnessPhoneNumber1);
    },

    async testSign() {
      this.overlay = true
      this.signImageUrl = this.$refs.handWrite.getCanvas().toDataURL()

      const existingPdfBytes = await fetch(this.pdfLink).then(res => res.arrayBuffer())
      const pdfDoc = await PDFDocument.load(existingPdfBytes)
      const pages = pdfDoc.getPages()

      //page1 input
      const page1 = pages[0]

      const imageSign = await pdfDoc.embedPng(this.signImageUrl)
      const pngDims = imageSign.scaleToFit(113.39, 56.69)
      page1.drawImage(imageSign, {
          x: this.getFinalX(3.00),
          y: this.getFinalY(23.40),
          width: pngDims.width,
          height: pngDims.height,
      })

      //generate and download.
        const pdfBytes = await pdfDoc.save()
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Witness-Form-" + this.policyHolderName + ".pdf";
        link.click();
        URL.revokeObjectURL(link.href);
    },

    testDb() {
      const db = getDatabase();
      //const ref = db.ref('records/witness_program');

      push(refDb(db, 'records/witness_program'), {
        username: 'name',
        email: 'email',
        profile_picture : 'imageUrl'
      })
      .then(() => {
        // Data saved successfully!
      })
      .catch((error) => {
        // The write failed...
        console.log(error);
      });

      //success!

      /*ref.push().set({
        author: 'alanisawesome',
        title: 'The Turing Machine'
      });*/
    },
    //experiment code. -[ end ]--------------------------------
  }
}
</script>

<style lang="scss">
.hasBorder {
  border-style: solid;
  border-width: 1px;
  border-color:grey;
}

.sig-canvas {
  width: 300px;
  height: 200px;
  background-color: rgba(244,244,244,0);
  border-style: solid;
  border-width: 1px;
}

.text-input input{
  text-transform: uppercase
}
</style>
